module.exports = __webpack_public_path__ + "static/johndigweed_2-823ad285feb121099fc97a5545d34dde.jpg";